import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { User } from '../types/user.type';
import { ADMIN_USERS_API_PATHS } from '../constants/users-paths.constants';

type UseRestoreUserResult = {
  restoreUser: (userId: string) => Promise<User | null>;
  isSubmitting: boolean;
};

export function useRestoreUser(): UseRestoreUserResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreUser = async (userId: string): Promise<User | null> => {
    setIsSubmitting(true);

    try {
      const restoredUser = await HttpClient.post<User>(ADMIN_USERS_API_PATHS.RESTORE_USER(userId));

      enqueueSnackbar('Client réactivé', { variant: 'success' });
      return restoredUser;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la réactivation du client'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreUser, isSubmitting };
}
